import { Typography, Box } from "@mui/material";

interface PageHeaderProps {
  image: string;
  title: string;
  header?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ image, title, header }) => {
  return (
    <Box
      sx={{
        height: "700px",
        width: "100%",
        position: "relative",
        zIndex: -1,
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(97, 97, 97, 0.15)",
        },
      }}
    >
      <img
        src={image}
        alt="page-header"
        style={{
          width: "100%",
          height: "700px",
          objectFit: "cover",
          display: "block",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "white",
          textAlign: "center",
          maxWidth: "700px",
        }}
      >
        {header && (
          <Typography
            sx={{
              fontSize: {
                xs: "16px",
                md: "24px",
              },
              fontWeight: 400,
              lineHeight: 1.4,
              marginBottom: "24px",
            }}
          >
            {header}
          </Typography>
        )}
        <Typography
          sx={{
            fontSize: {
              xs: "32px",
              md: "48px",
            },
            fontWeight: 600,
            lineHeight: 1.4,
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default PageHeader;
